var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "error-log" },
    [
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.search($event)
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "來源" } },
            [
              _c(
                "el-select",
                {
                  attrs: { disabled: _vm.loading, placeholder: "請選擇來源" },
                  model: {
                    value: _vm.filters.source,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "source", $$v)
                    },
                    expression: "filters.source",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "3gtapp", value: "3gtapp" },
                  }),
                  _c("el-option", { attrs: { label: "tc", value: "tc" } }),
                  _c("el-option", {
                    attrs: { label: "guideo", value: "guideo" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "錯誤代碼" } },
            [
              _c("el-input", {
                staticStyle: { width: "180px" },
                attrs: {
                  clearable: "",
                  disabled: _vm.loading,
                  placeholder: "輸入錯誤代碼",
                },
                model: {
                  value: _vm.filters.errorCode,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.filters,
                      "errorCode",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "filters.errorCode",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "應用程式" } },
            [
              _c("el-input", {
                staticStyle: { width: "220px" },
                attrs: {
                  clearable: "",
                  disabled: _vm.loading,
                  placeholder: "輸入應用程式名稱",
                },
                model: {
                  value: _vm.filters.applicationName,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.filters,
                      "applicationName",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "filters.applicationName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "例外訊息" } },
            [
              _c("el-input", {
                staticStyle: { width: "220px" },
                attrs: {
                  clearable: "",
                  disabled: _vm.loading,
                  placeholder: "輸入例外訊息",
                },
                model: {
                  value: _vm.filters.exceptionMessage,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.filters,
                      "exceptionMessage",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "filters.exceptionMessage",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "紀錄時間" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "datetimerange",
                  disabled: _vm.loading,
                  "range-separator": "至",
                  "start-placeholder": "開始時間",
                  "end-placeholder": "結束時間",
                  format: "yyyy-MM-dd HH:mm:ss",
                  "value-format": "yyyy-MM-dd HH:mm:ss",
                  clearable: "",
                },
                model: {
                  value: _vm.filters.recordedAtRange,
                  callback: function ($$v) {
                    _vm.$set(_vm.filters, "recordedAtRange", $$v)
                  },
                  expression: "filters.recordedAtRange",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "排序" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100px" },
                  attrs: { disabled: _vm.loading },
                  model: {
                    value: _vm.filters.recordedAtOrder,
                    callback: function ($$v) {
                      _vm.$set(_vm.filters, "recordedAtOrder", $$v)
                    },
                    expression: "filters.recordedAtOrder",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "新到舊", value: "desc" },
                  }),
                  _c("el-option", { attrs: { label: "舊到新", value: "asc" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "每次載入" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "90px" },
                  attrs: { disabled: _vm.loading },
                  on: { change: _vm.search },
                  model: {
                    value: _vm.limit,
                    callback: function ($$v) {
                      _vm.limit = $$v
                    },
                    expression: "limit",
                  },
                },
                [
                  _c("el-option", { attrs: { value: 10, label: "10 筆" } }),
                  _c("el-option", { attrs: { value: 20, label: "20 筆" } }),
                  _c("el-option", { attrs: { value: 50, label: "50 筆" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { margin: "8px 0 0 8px" } },
            [
              _c("el-button", {
                attrs: {
                  type: "primary",
                  icon: "el-icon-search",
                  loading: _vm.loading,
                  circle: "",
                },
                on: { click: _vm.search },
              }),
              _c("el-button", {
                attrs: {
                  icon: "el-icon-refresh",
                  disabled: _vm.loading,
                  circle: "",
                },
                on: { click: _vm.resetFilters },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          ref: "listContainer",
          staticClass: "list-container",
          on: {
            "&scroll": function ($event) {
              return _vm.handleScroll($event)
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading && _vm.events.length === 0,
                  expression: "loading && events.length === 0",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.events,
                border: "",
                fit: "",
                "highlight-current-row": "",
                size: "mini",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.$index + 1) + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "紀錄時間", width: "170" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.recorded_at || "-") + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "Event ID",
                  "min-width": "250",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.error_event_id || "-") + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "來源 / 應用程式",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.source || "-"))]),
                        _c(
                          "el-tag",
                          { attrs: { size: "mini", type: "info" } },
                          [_vm._v(_vm._s(scope.row.application_name || "-"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "HTTP 狀態", width: "105" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.statusTagType(scope.row.status_code),
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(scope.row.status_code || "-") + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "錯誤標題 / 代碼",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.title || "-"))]),
                        scope.row.error_code
                          ? _c(
                              "el-tag",
                              { attrs: { size: "mini", type: "warning" } },
                              [_vm._v(" " + _vm._s(scope.row.error_code) + " ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "例外訊息",
                  "min-width": "300",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          " " + _vm._s(scope.row.exception_message || "-") + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "詳細內容",
                  width: "100",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetails(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 查看 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "load-more" },
            [
              _vm.events.length
                ? _c("span", [
                    _vm._v(_vm._s("已載入 " + _vm.events.length + " 筆")),
                  ])
                : _vm._e(),
              !_vm.hasMore && _vm.events.length
                ? _c("span", [_vm._v("已無更多資料")])
                : !_vm.loading && !_vm.events.length
                ? _c("span", [_vm._v("查無資料")])
                : _vm._e(),
              _vm.hasMore && _vm.events.length
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "text", loading: _vm.loading },
                      on: { click: _vm.loadMore },
                    },
                    [_vm._v(" 載入更多 ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "異常事件詳細資料",
            visible: _vm.detailVisible,
            width: "850px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
            closed: function ($event) {
              _vm.selectedEvent = null
            },
          },
        },
        [
          _vm.selectedEvent
            ? _c(
                "div",
                { staticClass: "event-details" },
                [
                  _c(
                    "el-descriptions",
                    { attrs: { column: 2, border: "", size: "small" } },
                    [
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "Event ID" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedEvent.error_event_id || "-") +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "紀錄時間" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedEvent.recorded_at || "-") +
                              " "
                          ),
                        ]
                      ),
                      _c("el-descriptions-item", { attrs: { label: "來源" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.selectedEvent.source || "-") + " "
                        ),
                      ]),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "應用程式" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.selectedEvent.application_name || "-"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "HTTP 狀態" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedEvent.status_code || "-") +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "錯誤代碼" } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedEvent.error_code || "-") +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "關聯 ID", span: 2 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedEvent.correlation_id || "-") +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "錯誤標題", span: 2 } },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.selectedEvent.title || "-") + " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "例外類型", span: 2 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedEvent.exception_type || "-") +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "例外訊息", span: 2 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.selectedEvent.exception_message || "-"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "例外來源", span: 2 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.selectedEvent.exception_source || "-"
                              ) +
                              " "
                          ),
                        ]
                      ),
                      _c(
                        "el-descriptions-item",
                        { attrs: { label: "目標方法", span: 2 } },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.selectedEvent.target_site || "-") +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-collapse",
                    { staticClass: "detail-collapse" },
                    [
                      _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: "Problem Details",
                            name: "problem-details",
                          },
                        },
                        [
                          _c("pre", { staticClass: "detail-json" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatJson(
                                  _vm.selectedEvent.problem_details
                                )
                              )
                            ),
                          ]),
                        ]
                      ),
                      _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title:
                              "Stack Frames (" +
                              _vm.stackFrames(_vm.selectedEvent).length +
                              ")",
                            name: "stack-frames",
                          },
                        },
                        [
                          _vm.stackFrames(_vm.selectedEvent).length
                            ? _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.stackFrames(_vm.selectedEvent),
                                    border: "",
                                    size: "mini",
                                    "max-height": "360",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "frame_index",
                                      label: "#",
                                      width: "55",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "method_name",
                                      label: "方法",
                                      "min-width": "240",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "file_path",
                                      label: "檔案",
                                      "min-width": "240",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "line_number",
                                      label: "行號",
                                      width: "70",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "堆疊文字",
                                      "min-width": "300",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "pre",
                                                { staticClass: "frame-text" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.frame_text ||
                                                        "-"
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3813322452
                                    ),
                                  }),
                                ],
                                1
                              )
                            : _c("el-empty", {
                                attrs: { description: "沒有 Stack Frames" },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }